import { LANGUAGES } from "../../../../i18n/locales";
import { useDispatch, useSelector } from "react-redux";
import { setLocale } from "../../../../store/AppStore";
import React from "react";
import { FormattedMessage } from "react-intl";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

export const SwitchLocale = () => {

    const dispatch = useDispatch();
    const locale = useSelector((state:any) => state.app.locale);

    const handleChange = (e : React.FormEvent) => {
        var value = ((e.target) as any).value;
        localStorage.setItem('locale', value)
        dispatch(setLocale(value))        
    }

    return (        
          <Form.Group as={Row} className="locale-switcher" controlId="formSwitchLocale" style={{padding: "15px 0px"}}>
            {/* <Form.Label column sm="4">
              <FormattedMessage id="language"></FormattedMessage>:
            </Form.Label> */}
            <Col>
              <select className="form-control" onChange={handleChange} value={locale}>
                {LANGUAGES.map(({ short, code }) => (
                  <option key={code} value={code}>
                    {short}
                  </option>
                ))}
              </select>
            </Col>
          </Form.Group>        
    );
}